import React, { useEffect, useState } from 'react';
import axios from "axios";

function ContactForm() {
    const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    type: "一般諮詢",
    message: "",
    });

    const [service, setService] = useState([]);
    useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/service`)
        .then(res => {
        setService(res.data);
        if (res.data.length > 0) {
            setFormData(prev => ({ ...prev, type: res.data[0].title }));
        }
        })
        .catch(err => console.error("載入服務項目失敗", err));
    }, []);

    const handleChange = (e) => {
    setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
    }));
    };

    const handleSubmit = async (e) => {
    e.preventDefault();

    try {
        await axios.post(`${process.env.REACT_APP_API_URL}/contact`, formData);
        alert("留言已送出，我們將盡快聯絡您！");
    } catch (err) {
        alert("送出失敗，請稍後再試");
        console.error(err);
    }
    };

    return (
    <form onSubmit={handleSubmit} className="space-y-4 font-body text-sm text-textPrimary">
        <div>
        <label className="block mb-1">姓名</label>
        <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full border rounded px-3 py-2"
        />
        </div>
        <div>
        <label className="block mb-1">Email</label>
        <input
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border rounded px-3 py-2"
        />
        </div>
        <div>
        <label className="block mb-1">電話</label>
        <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
        />
        </div>
        <div>
        <label className="block mb-1">類型</label>
        <select
            name="type"
            value={formData.type}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
        >
        {service.length === 0 ? (
            <option disabled>載入中...</option>
            ) : (
            service.map((service, idx) => (
                <option key={idx} value={service.title}>
                {service.title}
                </option>
            ))
        )}
        <option>其他</option>
        </select>
        <select>其他</select>
        </div>

        <div>
        <label className="block mb-1">留言內容</label>
        <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="4"
            className="w-full border rounded px-3 py-2"
        ></textarea>
        </div>
        <button
        type="submit"
        className="bg-secondary text-white px-6 py-2 rounded hover:bg-opacity-90"
        >
        送出留言
        </button>
    </form>
    );
    }

    export default ContactForm;
